import { render, staticRenderFns } from "./Frontali.vue?vue&type=template&id=032f2c85&scoped=true"
import script from "./Frontali.vue?vue&type=script&lang=ts"
export * from "./Frontali.vue?vue&type=script&lang=ts"
import style0 from "./Frontali.vue?vue&type=style&index=0&id=032f2c85&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032f2c85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032f2c85')) {
      api.createRecord('032f2c85', component.options)
    } else {
      api.reload('032f2c85', component.options)
    }
    module.hot.accept("./Frontali.vue?vue&type=template&id=032f2c85&scoped=true", function () {
      api.rerender('032f2c85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Frontali.vue"
export default component.exports